import React, { useState } from 'react';
import './../../../Styles/Inbox/OrderDetails.css';
import SideMenuBar from '../../../Components/Layouts/SideMenuBar';
import TopMenuBar from '../../../Components/Layouts/TopMenuBar';
import RightSideBar from '../../../Components/Layouts/RightSideBar';
import { useParams } from 'react-router-dom';
import OrderInvoicePdf from './OrderInvoicePdf';
import { PDFDownloadLink } from '@react-pdf/renderer';
import BackButton from '../../../Components/BackButton';
import Loader from '../../../Components/Loader/Loader';
import OrderInfo from './OrderInfo';

const OrderDetails = () => {

    const [orderInvoiceData, setOrderInvoiceData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const { id } = useParams();

    return (
        <div className='order-details-container'>
            {isLoading && (
                <div>
                    <Loader/>
                </div>
            )}
            <div className='topmenubar order-mobile-topmenubar'>
                <SideMenuBar />
                <div className='top-bar-mobile'>
                    <TopMenuBar />
                </div>
            </div>
            <div className='order-detail-model'>
                <div className='order-detail-container1'>
                    <BackButton style={{marginBottom:'20px'}}/>
                    <p className='order-detail-title'>Orders Detail</p>
                    <OrderInfo setIsLoading={setIsLoading} orderInvoiceData={orderInvoiceData} setOrderInvoiceData={setOrderInvoiceData} id={id} />

                    {orderInvoiceData && (
                        <PDFDownloadLink
                            document={<OrderInvoicePdf orderInvoiceData={orderInvoiceData} />}
                            fileName={`Order_${orderInvoiceData?.Order_ID}.pdf`}
                            className="download-btn"
                        >
                            {({ loading }) => (loading ? 'Generating PDF...' : 'Download Invoice')}
                        </PDFDownloadLink>
                    )}
                </div>
            </div>

            <RightSideBar />
        </div>
    );
};

export default OrderDetails;
